import { debounceJukeboxRequestAction } from 'sharedActions/sharedActions';
import {
  mapDispatchButtonGroup,
  mapStateTextDisplay
} from 'reg_redesign/redux/connectFunctions';
import BasicInput from '@opploans/basic-input-component/BasicInput';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';
import ReferralSubtext from 'reg_redesign/ReferralSubtext';
import TextDisplay from 'components/component_lib/TextDisplay';

const page2 = {
  defaultNextPage: 'page-3',
  content: [
    configureProgressBar(0),
    configureTitle(['Let’s start simple.', 'What’s your name?']),
    {
      component: BasicInput,
      name: 'firstName',
      props: {
        id: 'firstName',
        label: 'First Name',
        maxLength: 40,
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        onChange: debounceJukeboxRequestAction
      }
    },
    {
      component: BasicInput,
      name: 'lastName',
      props: {
        id: 'lastName',
        label: 'Last Name',
        maxLength: 40,
        formControlStyle: {
          marginBottom: '1.5rem'
        },
        onChange: debounceJukeboxRequestAction
      }
    },
    {
      component: TextDisplay,
      name: 'referral',
      stateToPropsOverride: mapStateTextDisplay,
      props: {
        containerStyle: {
          display: 'flex',
          justifyContent: 'center',
          margin: '1.5rem 0'
        },
        textStyle: {
          fontSize: '1.25rem',
          fontWeight: 400,
          lineHeight: '1.5rem',
          textAlign: 'center'
        }
      },
      textContent: 'Were you referred by a friend?'
    },
    {
      component: ButtonGroup,
      name: 'isReferral',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'isReferral',
        options: [
          {
            displayValue: 'Yes',
            id: 'isReferralYes',
            value: 'true'
          },
          {
            displayValue: 'No',
            id: 'isReferralNo',
            value: 'false'
          }
        ]
      }
    },
    {
      component: ReferralSubtext,
      name: 'referralSubtext',
      props: {
        id: 'referralSubtext'
      }
    },
    nextButtonConfig('page-2')
  ]
};

export default page2;
